import { render, staticRenderFns } from "./ModalPagination.vue?vue&type=template&id=d952e092&"
import script from "./ModalPagination.vue?vue&type=script&lang=js&"
export * from "./ModalPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports